import { render, staticRenderFns } from "./EstadisticasGenerales.vue?vue&type=template&id=abf26042"
import script from "./EstadisticasGenerales.vue?vue&type=script&lang=js"
export * from "./EstadisticasGenerales.vue?vue&type=script&lang=js"
import style0 from "./EstadisticasGenerales.vue?vue&type=style&index=0&id=abf26042&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports